import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { siteColors } from '../Styles/SiteColors';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: siteColors.lightGray,
    },
    progress: {
        color: siteColors.lightGreen,
        marginLeft: 10,
        marginBottom: 50
    },
    circle: {
        strokeLinecap: 'round'
    },
}));

interface Props {
    open: boolean,
    size?: number,
    thickness?: number,
    variant?: 'determinate' | 'indeterminate' | 'static';

}

function OverlayLoader(props: Props = { open: false, variant: "indeterminate", size: 20, thickness: 3}) {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Backdrop className={classes.backdrop} open={props.open}>
                <CircularProgress
                    variant={props.variant}
                    size={props.size}
                    thickness={props.thickness}
                    className={classes.progress}
                    classes={{ circle: classes.circle }}
                />
            </Backdrop>
        </React.Fragment>)
}

export default OverlayLoader
